var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"connection-status-container\">\n<div class=\"alert alert-success\" ng-if=\"connectionStatus === 'online'\" ng-mouseover=\"cancelClearTimer()\" ng-mouseleave=\"startClearTimer()\">\n{{'connectionStatus.messageConnected' | translate}}\n<span style=\"text-decoration: underline\" class=\"cursor-pointer\" ng-click=\"refresh()\">\n{{'connectionStatus.refreshNow' | translate}}\n</span>\n</div>\n<div class=\"alert alert-danger\" ng-if=\"connectionStatus === 'offline'\">\n{{'connectionStatus.messageDisconnected' | translate}}\n<span style=\"text-decoration: underline\" class=\"cursor-pointer\" ng-click=\"refresh()\">\n{{'connectionStatus.refreshNow' | translate}}\n</span>\n</div>\n</div>";
var id1="connection-status.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/connection-status/connection-status.html
// module id = 2492
// module chunks = 1